module.exports = __webpack_public_path__ + "img/all_pass_plus_vip.3d6b2ff5.svg";